<div class="login-page font-normal">
  <div class="login-container" [attr.aria-busy]="isLoading()">
    <div class="header p-10 flex items-center">
      <div class="img-cntr">
        <img src="./images/logo.png" width="100" height="100" alt="NCMS" />
      </div>
      <div class="m-auto">
        <h1>NIGERIA CASE MANAGEMENT SYSTEM</h1>
      </div>
    </div>
    <div class="content flex">
      <div class="content-left">
        <div class="welcome-msg-header p-10 text-center">
          <h2 class="mb-0">Message from Chief Justice</h2>
        </div>
        <div class="welcome-msg-content p-10 text-sm">
          <p>Welcome to the Nigeria Case Management System. This will lead the way for our country in the use of
            technology for fair and transparent justice for our citizens.</p>
        </div>
      </div>
      <div class="content-center">
        <div class="login-info w-full">
          <form class="flex flex-col px-12" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <h2 class="text-xl mb-6">Log on</h2>
            <div class="flex flex-col">
              <mat-form-field class="rounded-md">
                <mat-icon matPrefix fontIcon="person" class="border-r border-solid text-slate-400"></mat-icon>
                <input type="text" formControlName="username" matInput placeholder="Username" />
                <mat-error class="!text-white">Field value required</mat-error>
              </mat-form-field>
            </div>
            <div class="flex flex-col">
              <mat-form-field class="rounded-md">
                <mat-icon matPrefix fontIcon="lock" class="border-r border-solid text-slate-400"></mat-icon>
                <input [type]="toggleShowPwd() ? 'text' : 'password'" formControlName="password" matInput
                  placeholder="Password" />
                <mat-icon matSuffix [fontIcon]="toggleShowPwd() ? 'visibility' : 'visibility_off'"
                  class="border-l border-solid text-slate-400" (click)="togglePwd()"
                  [ngClass]="{ 'text-slate-800': toggleShowPwd() }"></mat-icon>
                <mat-error class="!text-white">Field value required</mat-error>
              </mat-form-field>
            </div>
            <div class="flex flex-col ">
              <button type="submit" mat-flat-button color="primary" class="btn-sign" [disabled]="loginForm.invalid"
                [ngClass]="{'cursor-hidden': loginForm.invalid, 'cursor-pointer': loginForm.valid}">
                Login
              </button>
              <button type="button" style="color: white" class="self-start px-0" (click)="onForgotPassword()">Forgot
                Password?</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="footer p-10">Copyright © 2024, National Judicial Council of Nigeria, NCMS, Version: {{ version }}
    </div>
  </div>
  <div *ngIf="isLoading()" class="fixed inset-0 z-[1100]  backdrop-blur-sm grid place-items-center">
    <div class="rounded-2xl px-6 py-5 shadow-xl bg-neutral-900/70 text-white flex flex-col items-center gap-3">
      <mat-progress-spinner mode="indeterminate" diameter="48" color="primary"></mat-progress-spinner>
    </div>
  </div>